import { Component, Inject, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { SaleTeamMappingEmployeeInfo } from '../model/SaleTeamMappingEmployeeInfo.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalService } from '../service/global.service';
import { ActivatedRoute } from '@angular/router';
import { TokenService } from '../service/token.service';
import { environment } from 'src/environments/environment';
import { ProjectSaleInfo } from '../model/projectsale.model';
import { ProjectSaleReportInfo } from '../model/ProjectSaleReportInfo.model';
import { AssetGroupInfo } from '../model/AssetGroupInfo.model';
import { AssetPortfolioInfo } from '../model/AssetPortfolioInfo.model';
//import { ChartOptions, ChartType } from 'chart.js';
//import { ChartDataSets } from 'chart.js';
import { BaseChartDirective, Label } from 'ng2-charts';
import { promise } from 'protractor';
import { ProjectsalereportComponent } from '../projectsalereport/projectsalereport.component';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import { Chart } from 'chart.js';

export interface AssetTypeMonthSummary {
  year: number;
  month: number;
  assetTypeName: string;
  totalPrice: number;
}

export interface AssetTypeMonthlySummary {
  AssetTypeName: string;
  January?: number;
  February?: number;
  March?: number;
  April?: number;
  May?: number;
  June?: number;
  July?: number;
  August?: number;
  September?: number;
  October?: number;
  November?: number;
  December?: number;
  TotalPrice?: number;
}

export interface AssetReportGroupSummary {
  AssetReportGroupNo: string;
  AssetReportGroupName: string;
  AssetTypeName: string;
  January?: number;
  February?: number;
  March?: number;
  April?: number;
  May?: number;
  June?: number;
  July?: number;
  August?: number;
  September?: number;
  October?: number;
  November?: number;
  December?: number;
  TotalPrice?: number;
}

@Component({
  selector: 'app-projectsale-asset-group-report',
  templateUrl: './projectsale-asset-group-report.component.html',
  styleUrls: ['./projectsale-asset-group-report.component.css']
})
export class ProjectsaleAssetGroupReportComponent implements OnInit {
 _ForK2: string;
  _EmpCode: string;
  _ParamEmpCode: string;

  baseurl: string;

  public datalabelsPlugin = [ChartDataLabels];

  yearOptions: ProjectSaleInfo[] = [];
  quarterOptions: string[] = [];
  monthOptions: { value: string; label: string }[] = [];
  SaleTargetYearList: string[] = [];

  // Search variables
  periodSearch: string = 'YEAR';
  yearSearch: string = null;
  noYearBack: number = 5;
  quarterSearch: string = null;
  monthSearch: string = null;
  txtSearchSaleTeam: string = null;

  assetGroupNameForAG00001: string = '';
  assetGroupNameForAG00002: string = '';

  SaleTeamList: SaleTeamMappingEmployeeInfo[] = [];
  SaleTeamUnderList: SaleTeamMappingEmployeeInfo[] = [];
  SaleTeamMappingRequestList: SaleTeamMappingEmployeeInfo[] = [];
  IsSaleTeamMap: boolean = true;

  // Main Data
  AssetGroupList: AssetGroupInfo[] = [];
  SaleTeamTargetList: ProjectSaleReportInfo[] = [];
  SaleTeamActualList: ProjectSaleReportInfo[] = [];

  SaleTargetSAssetGroupList: ProjectSaleReportInfo[] = [];
  SaleActualSAssetGroupList: ProjectSaleReportInfo[] = [];

  // Main Detail Data
  AssetGroupDetailList: AssetGroupInfo[] = [];
  TargetGroupDetailList: ProjectSaleReportInfo[] = [];
  ActualPricebyCategoryList: ProjectSaleReportInfo[] = [];
  ActualPricebyTypeList: ProjectSaleReportInfo[] = [];
  isDataReady = false;
  isDataByTeamReady = false;

  modalPeriodSelected = "YEAR";
  yearValidationError: boolean = false;

  showGroupByTeam: boolean = false;
  showGroupNoTeam: boolean = true;
  showGroupDetail: boolean = false;

  showGroupDetailByTeam: boolean = false;

  GroupCodeClicked: string = '';
  YearClicked: string = '';

  GroupCodeClickedByTeam: string = '';
  YearClickedByTeam: string = '';
  TeamCodeClick: string = '';

  // Zone modal graph
  //AssetTypeActualMonthlyList: AssetTypeMonthSummary[] = []; (Test step raw data before expand)
  AssetTypeActualMonthlyList: AssetTypeMonthlySummary[] = [];
  ActualAssetReportGroupSummaryList: AssetReportGroupSummary[] = [];
  ActualAssetReportGroupTeamSummaryList: AssetReportGroupSummary[] = [];

  AssetPortfolioMasterList: AssetPortfolioInfo[] = [];
  // Zone modal graph

  // Zone pagination variable
  public indexNo: number = 0;
  public currentPageNumber: number = 0;
  public totalPages: number = 0;
  public totalItems: number = 0;
  public environment: number = 999999

  chartAssetGroups: {
    assetGroupCode: string;
    assetGroupName: string;
    labels: string[];
    datasets: any[];
  }[] = [];

  chartPerTeam: {
    teamCode: string;
    teamName: string;
    assetGroupCharts: {
      assetGroupCode: string;
      assetGroupName: string;
      labels: string[];
      datasets: any[];
    }[];
  }[] = [];

  barChartOptions: any = {
  responsive: true,
  scales: {
    xAxes: [{}],
    yAxes: [{
      ticks: { 
        beginAtZero: true,
        callback: function(value) {
          return value.toLocaleString();
        }
      }
    }]
  },
  tooltips: {
    callbacks: {
      label: function(tooltipItem, data) {
        const label = data.datasets[tooltipItem.datasetIndex].label || '';
        const value = tooltipItem.yLabel;
        return `${label}: ${Number(value).toLocaleString()}`;
      }
    }
  },
  plugins: {
      datalabels: {
        anchor: 'end', // ตำแหน่งของ Label (end: บนสุด, start: ล่างสุด, center: ตรงกลาง)
        align: 'top', // จัดแนวของ Label (top, bottom, center)
        color: '#000', // สีตัวอักษรของ Label
        font: {
          weight: 'bold' // ทำให้ตัวอักษรหนา
        },
        formatter: function(value: any) { // ฟังก์ชันจัดรูปแบบตัวเลขที่จะแสดง
          const numericValue = Number(value);
          if (numericValue >= 0) {
            if (numericValue >= 1000000) {
              return (numericValue / 1000000).toFixed(2) + 'M';
            }
            return numericValue.toLocaleString();
            } else {
            return null; // หากค่าน้อยกว่าหรือเท่ากับ 0 จะไม่แสดง label
          }
        }
      }
    }
  };

  // Properties to hold chart data
  public chartLabels: string[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  public chartDatasets: any[] = [];
  public barChartOptionsnewdesc: any = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: [{
        ticks: {
          fontFamily: 'Inter, sans-serif'
        },
        gridLines: {
            display: false
        }
      }],
      yAxes: [{
        ticks: {
          beginAtZero: true,
          callback: function(value) {
            return Number(value).toLocaleString();
          },
          fontFamily: 'Inter, sans-serif'
        },
        scaleLabel: {
          display: false,
          labelString: 'Price',
          fontFamily: 'Inter, sans-serif'
        }
      }]
    },
    tooltips: {
      callbacks: {
        label: function(tooltipItem, data) {
          const label = data.datasets[tooltipItem.datasetIndex].label || '';
          const value = tooltipItem.yLabel;
          return `${label}: ${Number(value).toLocaleString()}`;
        }
      }
    },
    // ส่วนของ legend ที่ถูกแก้ไขให้แสดง legend ปกติ
    legend: {
      display: true,
      position: 'top',
      align: 'start',
    },
    plugins: {
      datalabels: {
        anchor: 'end', // ตำแหน่งของ Label (end: บนสุด, start: ล่างสุด, center: ตรงกลาง)
        align: 'top', // จัดแนวของ Label (top, bottom, center)
        color: '#000', // สีตัวอักษรของ Label
        font: {
          weight: 'bold' // ทำให้ตัวอักษรหนา
        },
        formatter: function(value: any) { // ฟังก์ชันจัดรูปแบบตัวเลขที่จะแสดง
          const numericValue = Number(value);
          if (numericValue >= 0) {
            if (numericValue >= 1000000) {
              return (numericValue / 1000000).toFixed(2) + 'M';
            }
            return numericValue.toLocaleString();
            } else {
            return null; // หากค่าน้อยกว่าหรือเท่ากับ 0 จะไม่แสดง label
          }
        }
      }
    }
  };

  public chartLabelsTeam: string[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  public chartDatasetsTeam: any[] = [];
  
  public barChartOptionsTeamnewdesc: any = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: [{
        ticks: {
          fontFamily: 'Inter, sans-serif'
        },
        gridLines: {
            display: false
        }
      }],
      yAxes: [{
        ticks: {
          beginAtZero: true,
          callback: function(value) {
            return Number(value).toLocaleString();
          },
          fontFamily: 'Inter, sans-serif'
        },
        scaleLabel: {
          display: false,
          labelString: 'Price',
          fontFamily: 'Inter, sans-serif'
        }
      }]
    },
    tooltips: {
      callbacks: {
        label: function(tooltipItem, data) {
          const label = data.datasets[tooltipItem.datasetIndex].label || '';
          const value = tooltipItem.yLabel;
          return `${label}: ${Number(value).toLocaleString()}`;
        }
      }
    },
    hover: {
      mode: 'index',
      intersect: false
    },
    legend: {
      display: true,
      position: 'top',
      align: 'start',
    },
    plugins: {
      datalabels: {
        anchor: 'end', // ตำแหน่งของ Label (end: บนสุด, start: ล่างสุด, center: ตรงกลาง)
        align: 'top', // จัดแนวของ Label (top, bottom, center)
        color: '#000', // สีตัวอักษรของ Label
        font: {
          weight: 'bold' // ทำให้ตัวอักษรหนา
        },
        formatter: function(value: any) { // ฟังก์ชันจัดรูปแบบตัวเลขที่จะแสดง
          const numericValue = Number(value);
          if (numericValue >= 0) {
            if (numericValue >= 1000000) {
              return (numericValue / 1000000).toFixed(2) + 'M';
            }
            return numericValue.toLocaleString();
            } else {
            return null; // หากค่าน้อยกว่าหรือเท่ากับ 0 จะไม่แสดง label
          }
        }
      }
    }
  };

  TotalPurchasePriceAll: string = '';
  TotalPurchasePriceAllByTeam: string = '';

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, 
              private formBuilder: FormBuilder, private GlobalService: GlobalService, 
              private activatedRoute: ActivatedRoute, private TokenService: TokenService) { 
                this.baseurl = environment.base_api;
                this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
                this._ParamEmpCode = this.activatedRoute.snapshot.params.EmpCode;
               }

  async ngOnInit(): Promise<void> {
    this._EmpCode = !!this._ParamEmpCode ? this._ParamEmpCode : localStorage.getItem("EmpCode");
      if (!!this._ForK2) {
        localStorage.setItem("EmpCode", this._ParamEmpCode);
      }

      Chart.plugins.register(ChartDataLabels);

      await this.initializeComponent();
      await this.loadSaleTeamMapping();
      await this.loadTeamTarget();
      await this.loadTeamActual();
      await this.loadAssetGroup();
      await this.loadAssetGroupTarget();
      await this.loadAssetGroupActual();      
      //this.extractSpecificAssetGroupNames(this.SaleTeamTargetList);
      this.generateChartDataPerTeamAndAssetGroup();
      this.generateChartDataAssetGroup();

      //this.loadAssetGroupDetailList("G02"); // Test show AssetCategory under AssetGroup List#1
      //this.loadTargetGroupDetailList("G02", "2025"); // Test show Target Asset by Group Call List#2
      //this.loadActualPricebyCategoryList("G02", "2025"); // Test show Actual AssetCate by Group Call List#2
      //this.loadActualPricebyTypeList("G02", "2025"); // Test show Actual AssetType by Group Call List#3//
  }

  async initializeComponent() {
    await this.loadInitialData();
  }

  async loadInitialData() {
    await this.loadLeadYears();
    await this.loadQuarterOptions();
    await this.loadMonthOptions();
    await this.loadSaleTeams(); //loadSaleTeams
    await this.LoadAssetPortfolioMasterList();
  }

  async loadLeadYears() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      try {
        const result = await this.httpClient.get<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetLeadYears", httpOptions).toPromise();
        if (result && result.length > 0) {
          this.yearOptions = result;
          //console.log('this.yearOptions', this.yearOptions)
          if (this.yearOptions.length >= 2) {
            this.yearSearch = this.yearOptions[this.yearOptions.length - 2].ProjectSaleYear;
          } else {
            this.yearSearch = this.yearOptions[0].ProjectSaleYear; // if yearOptions have only 1 list object
          }
          await this.onSelectYearChange();
          //console.log('Default year set to:', this.yearSearch);
        } else {          
          this.yearSearch = null;
          console.error('No years returned from GetLeadYears');
        }
      } catch (error) {
        console.error('Error loading years:', error);
      }
    }
  }

  async loadQuarterOptions() {
    this.quarterOptions = ['Q1', 'Q2', 'Q3', 'Q4'];
  }

  async loadMonthOptions() {
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    this.monthOptions = monthNames.map((name, index) => ({
      value: (index + 1).toString(),
      label: name
    }));
  }

  async loadSaleTeams() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
            })
        };

        var objectjson = {};
        objectjson['EmployeeCode'] = this._EmpCode;
        let strjson = JSON.stringify(objectjson);

        try {
            const data = await this.httpClient.post<SaleTeamMappingEmployeeInfo[]>(this.baseurl + "Team/GetEmpMappingTeam", strjson, httpOptions).toPromise();
            
            this.SaleTeamList = data;
            //console.log('loadSaleTeams: ข้อมูลทีมขายที่ได้รับ:', this.SaleTeamList);
            //console.log('loadSaleTeams: ตั้งค่า txtSearchSaleTeam เป็น:', this.txtSearchSaleTeam);

        } catch (error) {
            console.error('loadSaleTeams: Error โหลดทีมขาย:', error);
            this.SaleTeamList = [];
            this.txtSearchSaleTeam = null; 
        }
    } else {
        console.error('loadSaleTeams: Token ไม่พร้อมใช้งาน');
        this.SaleTeamList = [];
        this.txtSearchSaleTeam = null;
    }
}

  async loadAssetGroup() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
            })
        };

        var objectjson = {};
        objectjson['EmployeeCode'] = this._EmpCode;
        let strjson = JSON.stringify(objectjson);

        try {
            const data = await this.httpClient.post<AssetGroupInfo[]>(this.baseurl + "AssetType/GetAssetGroup", strjson, httpOptions).toPromise();
            
            this.AssetGroupList = data;
            //console.log('AssetGroupList: ', this.AssetGroupList);
            //console.log('loadSaleTeams: ตั้งค่า txtSearchSaleTeam เป็น:', this.txtSearchSaleTeam);

        } catch (error) {
            console.error('AssetGroupList: ', error);
            this.AssetGroupList = [];
        }
    } else {
        console.error('AssetGroupList: Token ไม่พร้อมใช้งาน');
        this.AssetGroupList = [];
    }
}

  async onSelectYearChange(): Promise<void> {
    if (!this.yearSearch) {
      this.yearValidationError = true;
      return;
    }
  
    this.yearValidationError = false;

    const selectedYear = parseInt(this.yearSearch); // such as "2025" -> 2025
    const backCount = this.noYearBack || 1;

    // clear and create year role back ['2025', '2024', ...]
    this.SaleTargetYearList = [];
    for (let i = 0; i < backCount; i++) {
      this.SaleTargetYearList.push((selectedYear - i).toString());
    }

    //console.log("เลือกปีหลัก:", this.yearSearch);
    //console.log("ปีที่ใช้ในการ filter:", this.SaleTargetYearList);

    await this.loadTeamTarget();
    await this.loadTeamActual();
    this.generateChartDataPerTeamAndAssetGroup();

    await this.loadAssetGroup();
    await this.loadAssetGroupTarget();
    this.generateChartDataAssetGroup();
  }

  async onNoYearChange(): Promise<void> {
  // Identify value selected from noYearBack and create YearBack
  const currentYear = parseInt(this.yearSearch); // Use year from dropdown
  const backCount = this.noYearBack || 1;

  this.SaleTargetYearList = []; // Clear list first
  for (let i = 0; i < backCount; i++) {
    this.SaleTargetYearList.push((currentYear - i).toString());
  }

  //console.log("🔁 ปีที่ส่ง:", this.SaleTargetYearList);

  // Reload
  await this.loadTeamTarget();
  await this.loadTeamActual();
  this.generateChartDataPerTeamAndAssetGroup()

  await this.loadAssetGroup();
  await this.loadAssetGroupTarget();
  this.generateChartDataAssetGroup();
  }

  async onSaleTeamChange(): Promise<void> {
    this.showGroupByTeam = !!this.txtSearchSaleTeam; // มีเลือกทีม => true
    this.showGroupNoTeam = !this.txtSearchSaleTeam; // ไม่มีเลือก => true เฉพาะตอนเลือก "All"

    if (this.txtSearchSaleTeam) {
      this.TeamCodeClick = this.txtSearchSaleTeam;
    } else {
      this.TeamCodeClick = "";
    }

    this.clearTableData();

    //console.log('Sale team changed:', this.txtSearchSaleTeam);
    await this.loadTeamTarget(); 
    await this.loadTeamActual();
    this.generateChartDataPerTeamAndAssetGroup();

    if (!this.txtSearchSaleTeam) {
      await this.loadAssetGroupTarget();
      await this.loadAssetGroupActual();
    }
  }

  async loadTeamTarget() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
            })
        };

        const startYear = parseInt(this.yearSearch ?? new Date().getFullYear().toString());
        const yearList = Array.from({ length: this.noYearBack }, (_, i) => (startYear - i).toString());

        const objectjson = {
        SaleTargetYearList: yearList, // string[]
        SaleTargetTeamCode: this.txtSearchSaleTeam, // string | null
        SaleTargetEmpCode: this._EmpCode
      };

        //console.log('loadTeamTarget: objectjson ที่จะส่ง:', objectjson);

        let strjson = JSON.stringify(objectjson);

        try {
            // *** แก้ไข 3: ใช้ await ตรงๆ กับ toPromise() ***
            const data = await this.httpClient.post<ProjectSaleReportInfo[]>(this.baseurl + "ProjectSaleReport/GetTeamAssetGrroupTargetReportPerformance", strjson, httpOptions).toPromise();
            this.SaleTeamTargetList = data;

            //console.log('load SaleTeamTargetList Group by Team & Year:', this.SaleTeamTargetList);//
        } catch (error) {
            console.error('loadTeamTarget: Error โหลดเป้าหมายทีม:', error);
            this.SaleTeamTargetList = []; // ตั้งค่าเป็น array ว่างเปล่าเมื่อเกิดข้อผิดพลาด
        }
    } else {
        console.error('loadTeamTarget: Token ไม่พร้อมใช้งาน');
    }
  }

  async loadTeamActual() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
            })
        };

        const startYear = parseInt(this.yearSearch ?? new Date().getFullYear().toString());
        const yearList = Array.from({ length: this.noYearBack }, (_, i) => (startYear - i).toString());

        const objectjson = {
        SaleTargetYearList: yearList, // string[]
        SaleTargetTeamCode: this.txtSearchSaleTeam, // string | null
        SaleTargetEmpCode: this._EmpCode,
        AllUnderEmpCode: this._EmpCode
      };

        //console.log('loadTeamTarget: objectjson ที่จะส่ง:', objectjson);

        let strjson = JSON.stringify(objectjson);

        try {
            // *** แก้ไข 3: ใช้ await ตรงๆ กับ toPromise() ***
            const data = await this.httpClient.post<ProjectSaleReportInfo[]>(this.baseurl + "ProjectSaleReport/GetTeamAssetActuaGroupReportTeamPerformance", strjson, httpOptions).toPromise();
            this.SaleTeamActualList = data;

            //console.log('loadTeamActual Group by Team & Year###:', this.SaleTeamActualList);
        } catch (error) {
            console.error('loadTeamActual: Error โหลดยอดรายได้ทีม:', error);
            this.SaleTeamActualList = []; // ตั้งค่าเป็น array ว่างเปล่าเมื่อเกิดข้อผิดพลาด
        }
    } else {
        console.error('loadTeamActual: Token ไม่พร้อมใช้งาน');
    }
  }

  private extractSpecificAssetGroupNames(data: ProjectSaleReportInfo[]): void {
  // Find groupCode: AG00001
  const foundAG00001 = data.find(item => item.AssetGroupCode?.toUpperCase() === 'AG00001');
  if (foundAG00001 && foundAG00001.AssetGroupName) {
    this.assetGroupNameForAG00001 = foundAG00001.AssetGroupName;
  } else {
    this.assetGroupNameForAG00001 = 'Not Found'; // หรือค่า default อื่นๆ
    //console.warn('AssetGroupCode AG00001 ไม่พบหรือไม่มีชื่อในข้อมูล.');
  }

  // Find groupCode: AG00002
  const foundAG00002 = data.find(item => item.AssetGroupCode?.toUpperCase() === 'AG00002');
  if (foundAG00002 && foundAG00002.AssetGroupName) {
    this.assetGroupNameForAG00002 = foundAG00002.AssetGroupName;
  } else {
    this.assetGroupNameForAG00002 = 'Not Found'; // หรือค่า default อื่นๆ
    //console.warn('AssetGroupCode AG00002 ไม่พบหรือไม่มีชื่อในข้อมูล.');
  }

  //console.log('Extracted specific Asset Group Names.');
}

  generateChartDataPerTeamAndAssetGroup() {
  const startYear = parseInt(this.yearSearch ?? new Date().getFullYear().toString());
  const numberOfYears = this.noYearBack ?? 1;
  //const yearList = Array.from({ length: numberOfYears }, (_, i) => (startYear - i).toString());
  const yearList = Array.from({ length: numberOfYears }, (_, i) => (startYear - i).toString()).reverse();
  const selectedTeamCode = this.txtSearchSaleTeam;

  const teamCodes = selectedTeamCode ? [selectedTeamCode] : this.SaleTeamList.map(t => t.SaleTeamCode);

  //const dynamicAssetGroups = this.AssetGroupList ?? [];
  const dynamicAssetGroups = this.AssetPortfolioMasterList ?? [];

  // Mock Data when no key binding object found
  for (const teamCode of teamCodes) {
    const teamName = this.SaleTeamList.find(t => t.SaleTeamCode === teamCode)?.SaleTeamName || teamCode;

    for (const assetGroup of dynamicAssetGroups) {
      for (const year of yearList) {
        // Mock Target data
        const hasTarget = this.SaleTeamTargetList.some(x =>
          x.SaleTargetTeamCode === teamCode &&
          x.SaleTargetYear === year &&
          x.AssetGroupCode === assetGroup.AssetPortfolioCode);
        if (!hasTarget) {
          this.SaleTeamTargetList.push({
            SaleTargetTeamCode: teamCode,
            SaleTargetTeamName: teamName,
            SaleTargetYear: year,
            SaleTargetAmount: 0,
            AssetGroupCode: assetGroup.AssetPortfolioCode,
            AssetGroupName: assetGroup.AssetPortfolioName,
            SaleTargetQuarter: null, SaleTargetMonth: null, SaleTargetFlagNewCust: null,
            SaleTargetEmpCode: null, ProjectSaleTeamCode: null, ProjectSaleTeamName: null,
            ProjectSaleYear: null, TotalActualPrice: null, AssetType: null,
            AssetCategoryCode: null, ProjectSaleSubState: null, RequesterEmpCode: null,
            AssetTypeName: null, AssetCategoryName: null
          });
        }

        // Mock Actual data
        const hasActual = this.SaleTeamActualList.some(x =>
          x.ProjectSaleTeamCode === teamCode &&
          x.ProjectSaleYear === year &&
          x.AssetGroupCode === assetGroup.AssetPortfolioCode);
        if (!hasActual) {
          this.SaleTeamActualList.push({
            ProjectSaleTeamCode: teamCode,
            ProjectSaleTeamName: teamName,
            ProjectSaleYear: year,
            TotalActualPrice: 0,
            AssetGroupCode: assetGroup.AssetPortfolioCode,
            AssetGroupName: assetGroup.AssetPortfolioName,
            SaleTargetEmpCode: null, SaleTargetTeamName: null, SaleTargetMonth: null,
            SaleTargetQuarter: null, SaleTargetTeamCode: null, ProjectSaleSubState: null,
            SaleTargetAmount: null, SaleTargetFlagNewCust: null, SaleTargetYear: null,
            AssetType: null, AssetCategoryCode: null, RequesterEmpCode: null,
            AssetTypeName: null, AssetCategoryName: null
          });
        }
      }
    }
  }

  // Group and summarize data
  const allKeys = new Set<string>();
  const teamNames = new Map<string, string>();
  const targetData = new Map<string, number>();
  const actualData = new Map<string, number>();

  for (const item of this.SaleTeamTargetList) {
    const key = `${item.SaleTargetTeamCode}_${item.SaleTargetYear}_${item.AssetGroupCode}`;
    allKeys.add(key);
    teamNames.set(item.SaleTargetTeamCode, item.SaleTargetTeamName || item.SaleTargetTeamCode);
    const value = Number(item.SaleTargetAmount ?? 0);
    targetData.set(key, (targetData.get(key) || 0) + (isNaN(value) ? 0 : value));
  }

  for (const item of this.SaleTeamActualList) {
    const key = `${item.ProjectSaleTeamCode}_${item.ProjectSaleYear}_${item.AssetGroupCode}`;
    allKeys.add(key);
    teamNames.set(item.ProjectSaleTeamCode, item.ProjectSaleTeamName || item.ProjectSaleTeamCode);
    const value = Number(item.TotalActualPrice ?? 0);
    actualData.set(key, (actualData.get(key) || 0) + (isNaN(value) ? 0 : value));
  }

  const groupedByTeam = new Map<string, {
    teamName: string;
    assetGroupCharts: {
      [assetGroupCode: string]: {
        assetGroupName: string;
        data: { year: string, target: number, actual: number }[];
      };
    };
  }>();

  for (const key of allKeys) {
    const [teamCode, year, assetGroupCode] = key.split('_');
    const target = targetData.get(key) || 0;
    const actual = actualData.get(key) || 0;
    const teamName = teamNames.get(teamCode) || teamCode;
    const assetGroupName = this.AssetPortfolioMasterList.find(x => x.AssetPortfolioCode  === assetGroupCode)?.AssetPortfolioName  || assetGroupCode;

    if (!groupedByTeam.has(teamCode)) {
      groupedByTeam.set(teamCode, {
        teamName,
        assetGroupCharts: {}
      });
    }
    const teamGroup = groupedByTeam.get(teamCode)!;
    if (!teamGroup.assetGroupCharts[assetGroupCode]) {
      teamGroup.assetGroupCharts[assetGroupCode] = {
        assetGroupName,
        data: []
      };
    }
    teamGroup.assetGroupCharts[assetGroupCode].data.push({ year, target, actual });
  }

  // Convert to chartPerTeam array and filter out empty charts
  this.chartPerTeam = [];
  const sortedTeams = Array.from(groupedByTeam.entries()).sort((a, b) => a[0].localeCompare(b[0]));

  for (const [teamCode, teamData] of sortedTeams) {
    if (this.txtSearchSaleTeam && teamCode !== this.txtSearchSaleTeam) {
      continue;
    }

    const assetGroupChartsWithData = dynamicAssetGroups
      .filter(group => teamData.assetGroupCharts[group.AssetPortfolioCode])
      .map(group => {
        const groupChart = teamData.assetGroupCharts[group.AssetPortfolioCode];
        //const sortedData = groupChart.data.sort((a, b) => a.year.localeCompare(b.year));
        const sortedData = groupChart.data.sort((a, b) => parseInt(a.year) - parseInt(b.year));

        const filteredChartData = sortedData.filter(d => d.target > 0 || d.actual > 0);

        const totalTarget = sortedData.reduce((sum, item) => sum + item.target, 0);
        const totalActual = sortedData.reduce((sum, item) => sum + item.actual, 0);

        // --- เพิ่ม console.log() ที่นี่ ---
        //console.log(`Team: ${teamData.teamName}, Asset Group: ${groupChart.assetGroupName}`);
        //console.log(`  Calculated Target: ${totalTarget}, Calculated Actual: ${totalActual}`);
        //console.log('------------------------------------');
        // ------------------------------------

        if (totalTarget > 0 || totalActual > 0) {
          return {
            assetGroupCode: group.AssetPortfolioCode,
            assetGroupName: groupChart.assetGroupName,
            labels: sortedData.map(d => d.year), // Use this code เมื่ออยากให้แกน X แสดงครบทุกปี
            //labels: filteredChartData.map(d => d.year), // Use this code เมื่ออยากให้แกน X แสดงเฉพาะปีที่มีข้อมูล
            datasets: [
              {
                label: 'Target',
                data: sortedData.map(d => d.target), // Use this code เมื่ออยากให้แกน X แสดงครบทุกปี
                //data: filteredChartData.map(d => d.target), // Use this code เมื่ออยากให้แกน X แสดงเฉพาะปีที่มีข้อมูล
                backgroundColor: function (context) {
                  const { ctx, chartArea } = context.chart;
                  if (!chartArea) return null;
                  const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
                  gradient.addColorStop(0, '#1A237E');
                  gradient.addColorStop(1, '#64B5F6');
                  return gradient;
                },
                borderColor: 'rgba(63, 81, 181, 1)',
                borderWidth: 2,
                hoverBackgroundColor: 'rgba(22, 42, 155, 0.9)',
                hoverBorderColor: 'rgba(63, 81, 181, 1)',
                hoverBorderWidth: 3,
                borderSkipped: 'bottom' as const,
              },
              {
                label: 'Actual',
                data: sortedData.map(d => d.actual), // Use this code เมื่ออยากให้แกน X แสดงครบทุกปี
                //data: filteredChartData.map(d => d.actual), // Use this code เมื่ออยากให้แกน X แสดงเฉพาะปีที่มีข้อมูล
                backgroundColor: function (context) {
                  const { ctx, chartArea } = context.chart;
                  if (!chartArea) return null;
                  const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
                  gradient.addColorStop(0, '#1B5E20');
                  gradient.addColorStop(1, '#A5D6A7');
                  return gradient;
                },
                borderColor: 'rgba(0, 200, 83, 0.8)',
                borderWidth: 2,
                hoverBackgroundColor: 'rgba(8, 100, 46, 0.9)',
                hoverBorderColor: 'rgba(0, 200, 83, 1)',
                hoverBorderWidth: 3,
                borderSkipped: 'bottom' as const,
              }
            ]
          };
        }
        return null;
      })
      .filter(chart => chart !== null);

    if (assetGroupChartsWithData.length > 0) {
      this.chartPerTeam.push({
        teamCode,
        teamName: teamData.teamName,
        assetGroupCharts: assetGroupChartsWithData
      });
    }
  }
}

  async loadAssetGroupTarget() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
            })
        };

        const startYear = parseInt(this.yearSearch ?? new Date().getFullYear().toString());
        const yearList = Array.from({ length: this.noYearBack }, (_, i) => (startYear - i).toString());

        const objectjson = {
        SaleTargetYearList: yearList, // string[]
        SaleTargetEmpCode: this._EmpCode
      };

        //console.log('loadTeamTarget: objectjson ที่จะส่ง:', objectjson);

        let strjson = JSON.stringify(objectjson);

        try {
            const data = await this.httpClient.post<ProjectSaleReportInfo[]>(this.baseurl + "ProjectSaleReport/GetAssetGroupTargetReportPerformance", strjson, httpOptions).toPromise();
            this.SaleTargetSAssetGroupList = data;

            //console.log('load SaleTargetSAssetGroupList:', this.SaleTargetSAssetGroupList);
        } catch (error) {
            console.error('load SaleTargetSAssetGroupList: Error:', error);
            this.SaleTargetSAssetGroupList = [];
        }
    } else {
        console.error('load SaleTargetSAssetGroupList: Token ไม่พร้อมใช้งาน');
    }
  }

  async loadAssetGroupActual() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
            })
        };

        const startYear = parseInt(this.yearSearch ?? new Date().getFullYear().toString());
        const yearList = Array.from({ length: this.noYearBack }, (_, i) => (startYear - i).toString());

        const objectjson = {
        SaleTargetYearList: yearList, // string[]
        SaleTargetTeamCode: this.txtSearchSaleTeam, // string | null
        SaleTargetEmpCode: this._EmpCode,
        AllUnderEmpCode: this._EmpCode
      };

        //console.log('loadTeamTarget: objectjson ที่จะส่ง:', objectjson);

        let strjson = JSON.stringify(objectjson);

        try {
            // *** แก้ไข 3: ใช้ await ตรงๆ กับ toPromise() ***
            const data = await this.httpClient.post<ProjectSaleReportInfo[]>(this.baseurl + "ProjectSaleReport/GetAssetGroupActualReportPerformance", strjson, httpOptions).toPromise();
            this.SaleActualSAssetGroupList = data;

        } catch (error) {
            console.error('loadTeamActual: Error โหลดยอดรายได้ทีม:', error);
            this.SaleActualSAssetGroupList = [];
        }
    } else {
        console.error('loadTeamActual: Token ไม่พร้อมใช้งาน');
    }
  }

  generateChartDataAssetGroup() {
  const startYear = parseInt(this.yearSearch ?? new Date().getFullYear().toString());
  const numberOfYears = this.noYearBack ?? 1;
  const yearList = Array.from({ length: numberOfYears }, (_, i) => (startYear - i).toString());

  // กรองข้อมูลตามปีที่เลือก
  const filteredTargetList = this.SaleTargetSAssetGroupList.filter(x => yearList.includes(x.SaleTargetYear));
  const filteredActualList = this.SaleActualSAssetGroupList.filter(x => yearList.includes(x.ProjectSaleYear));

  // ใช้ AssetGroupList จาก API
  const dynamicAssetGroups = this.AssetGroupList ?? [];

  // Mock data กรณีไม่มีข้อมูลจริง (ในปีและ asset group ที่กำหนด)
  for (const assetGroup of dynamicAssetGroups) {
    for (const year of yearList) {
      const hasTarget = filteredTargetList.some(x =>
        x.SaleTargetYear === year &&
        x.AssetGroupCode === assetGroup.AssetGroupCode);

      if (!hasTarget) {
        filteredTargetList.push({
          SaleTargetYear: year,
          SaleTargetAmount: 0,
          AssetGroupCode: assetGroup.AssetGroupCode,
          AssetGroupName: assetGroup.AssetGroupName,
          SaleTargetQuarter: null,
          SaleTargetMonth: null,
          SaleTargetFlagNewCust: null,
          SaleTargetEmpCode: null,
          ProjectSaleTeamCode: null,
          ProjectSaleTeamName: null,
          ProjectSaleYear: null,
          TotalActualPrice: null,
          AssetType: null,
          AssetCategoryCode: null,
          ProjectSaleSubState: null,
          SaleTargetTeamCode: null,
          SaleTargetTeamName: null,
          RequesterEmpCode: null,
          AssetTypeName: null,
          AssetCategoryName: null
        });
      }

      const hasActual = filteredActualList.some(x =>
        x.ProjectSaleYear === year &&
        x.AssetGroupCode === assetGroup.AssetGroupCode);

      if (!hasActual) {
        filteredActualList.push({
          ProjectSaleYear: year,
          TotalActualPrice: 0,
          AssetGroupCode: assetGroup.AssetGroupCode,
          AssetGroupName: assetGroup.AssetGroupName,
          SaleTargetEmpCode: null,
          SaleTargetTeamName: null,
          SaleTargetMonth: null,
          SaleTargetQuarter: null,
          SaleTargetTeamCode: null,
          ProjectSaleSubState: null,
          SaleTargetAmount: null,
          SaleTargetFlagNewCust: null,
          SaleTargetYear: null,
          AssetType: null,
          AssetCategoryCode: null,
          ProjectSaleTeamCode: null,
          ProjectSaleTeamName: null,
          RequesterEmpCode: null,
          AssetTypeName: null,
          AssetCategoryName: null
        });
      }
    }
  }

  // สร้าง key รวมจาก AssetGroupCode + Year
  const allKeys = new Set<string>();
  const assetGroupNames = new Map<string, string>();
  const targetData = new Map<string, number>();
  const actualData = new Map<string, number>();

  for (const item of filteredTargetList) {
    const key = `${item.AssetGroupCode}_${item.SaleTargetYear}`;
    allKeys.add(key);
    assetGroupNames.set(item.AssetGroupCode, item.AssetGroupName || item.AssetGroupCode);
    const value = Number(item.SaleTargetAmount ?? 0);
    targetData.set(key, (targetData.get(key) || 0) + (isNaN(value) ? 0 : value));
  }

  for (const item of filteredActualList) {
    const key = `${item.AssetGroupCode}_${item.ProjectSaleYear}`;
    allKeys.add(key);
    assetGroupNames.set(item.AssetGroupCode, item.AssetGroupName || item.AssetGroupCode);
    const value = Number(item.TotalActualPrice ?? 0);
    actualData.set(key, (actualData.get(key) || 0) + (isNaN(value) ? 0 : value));
  }

  // Group by AssetGroupCode
  const groupedByAssetGroup = new Map<string, {
    assetGroupName: string;
    data: { year: string; target: number; actual: number; }[];
  }>();

  for (const key of allKeys) {
    const [assetGroupCode, year] = key.split('_');
    const target = targetData.get(key) || 0;
    const actual = actualData.get(key) || 0;
    const assetGroupName = assetGroupNames.get(assetGroupCode) || assetGroupCode;

    if (!groupedByAssetGroup.has(assetGroupCode)) {
      groupedByAssetGroup.set(assetGroupCode, {
        assetGroupName,
        data: []
      });
    }

    groupedByAssetGroup.get(assetGroupCode)!.data.push({ year, target, actual });
  }

  // แปลงเป็น array สำหรับแสดงผล chart
  this.chartAssetGroups = [];

  for (const [assetGroupCode, groupData] of groupedByAssetGroup.entries()) {
    //const sortedData = groupData.data.sort((a, b) => a.year.localeCompare(b.year));
    const sortedData = groupData.data.sort((a, b) => parseInt(a.year) - parseInt(b.year));

    // **ขั้นตอนที่ 1: คำนวณผลรวมทั้งหมด**
    const totalTarget = sortedData.reduce((sum, item) => sum + item.target, 0);
    const totalActual = sortedData.reduce((sum, item) => sum + item.actual, 0);
    const yearList = Array.from({ length: numberOfYears }, (_, i) => (startYear - numberOfYears + 1 + i).toString());

    // **ขั้นตอนที่ 2 และ 3: ตั้งเงื่อนไขและ push เฉพาะกราฟที่มีข้อมูล**
    if (totalTarget > 0 || totalActual > 0) {
      // **ขั้นตอนที่ 1: สร้างชุดข้อมูลสำหรับทุกปีที่เลือก**
    const allYearsData: { year: string; target: number; actual: number; }[] = yearList.map(year => ({
      year: year,
      target: 0,
      actual: 0
    }));

    // **ขั้นตอนที่ 2: นำข้อมูลจริงจากกลุ่มที่มีข้อมูลแล้วมาเติม**
    for (const item of sortedData) {
      const existingYear = allYearsData.find(d => d.year === item.year);
      if (existingYear) {
        existingYear.target = item.target;
        existingYear.actual = item.actual;
      }
    }

      this.chartAssetGroups.push({
      assetGroupCode,
      assetGroupName: groupData.assetGroupName,
      //labels: sortedData.map(d => d.year), // ใช้ Code นี้ถ้า ต้องการแสดงเฉพาะปีที่มีข้อมูลจริง
      labels: allYearsData.map(d => d.year), // สลับใช้ Code นี้เพื่อ นำ allYearsData จาก dropdown ปีมา ใน canvas
      datasets: [
        {
          label: 'Target',
          data: sortedData.map(d => d.target), // ใช้ Code นี้ถ้า ต้องการแสดงเฉพาะปีที่มีข้อมูลจริง
          //data: allYearsData.map(d => d.target), // สลับใช้ Code นี้เพื่อ นำ allYearsData จาก dropdown ปีมา ใน canvas
          backgroundColor: function (context) {
            const { ctx, chartArea } = context.chart;
            if (!chartArea) return null;
            const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
            gradient.addColorStop(0, '#1A237E');
            gradient.addColorStop(1, '#64B5F6');
            return gradient;
          },
          borderColor: 'rgba(63, 81, 181, 1)',
          borderWidth: 2,
          hoverBackgroundColor: 'rgba(22, 42, 155, 0.9)',
          hoverBorderColor: 'rgba(63, 81, 181, 1)',
          hoverBorderWidth: 3,
          borderSkipped: 'bottom' as const,
        },
        {
          label: 'Actual',
          //data: sortedData.map(d => d.actual), // ใช้ Code นี้ถ้า ต้องการแสดงเฉพาะปีที่มีข้อมูลจริง
          data: allYearsData.map(d => d.actual), // สลับใช้ Code นี้เพื่อ นำ allYearsData จาก dropdown ปีมา ใน canvas
          backgroundColor: function (context) {
            const { ctx, chartArea } = context.chart;
            if (!chartArea) return null;
            const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
            gradient.addColorStop(0, '#1B5E20');
            gradient.addColorStop(1, '#A5D6A7');
            return gradient;
          },
          borderColor: 'rgba(0, 200, 83, 0.8)',
          borderWidth: 2,
          hoverBackgroundColor: 'rgba(8, 100, 46, 0.9)',
          hoverBorderColor: 'rgba(0, 200, 83, 1)',
          hoverBorderWidth: 3,
          borderSkipped: 'bottom' as const,
        }
      ]
      });
    }
  }

  //console.log('Generated chartAssetGroups:', this.chartAssetGroups);
  }

  async loadSaleTeamMapping() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
            })
        };

        const objectjson = {
        EmployeeCode: this._EmpCode
      };

        //console.log('loadTeamTarget: objectjson ที่จะส่ง:', objectjson);

        let strjson = JSON.stringify(objectjson);

        try {
            // *** แก้ไข 3: ใช้ await ตรงๆ กับ toPromise() ***
            const data = await this.httpClient.post<SaleTeamMappingEmployeeInfo[]>(this.baseurl + "Team/GetEmpMappingTeamRequest", strjson, httpOptions).toPromise();
            this.SaleTeamMappingRequestList = data;

            //console.log('data', data)

            if (this.SaleTeamMappingRequestList.length === 0) {
              this.IsSaleTeamMap = false;
            }

            //console.log('this.IsSaleTeamMap', this.IsSaleTeamMap)
            //console.log('load SaleTeamTargetList Group by Team & Year:', this.SaleTeamTargetList);
        } catch (error) {
            console.error('loadTeamTarget: Error โหลดทีมสังกัด:', error);
            this.SaleTeamTargetList = [];
        }
    } else {
        console.error('loadSaleTeamMapping: Token ไม่พร้อมใช้งาน');
    }
  }

  async onChartClick(event: any, groupChart: any): Promise<void> {
    // event.active => array of element clicked
    // If click in graph area (not in other area)
    if (event.active && event.active.length > 0) {
      const clickedElement = event.active[0];
      const datasetIndex = clickedElement._datasetIndex; // 0 for Target, 1 for Actual
      const elementIndex = clickedElement._index; // Index pf dataset (ex. year 2025)

      const labelClicked = groupChart.datasets[datasetIndex].label;
      const yearClicked = groupChart.labels[elementIndex];
      const valueClicked = groupChart.datasets[datasetIndex].data[elementIndex];

      this.showGroupDetail = false; // Update No show for current
      this.GroupCodeClicked = groupChart.assetGroupCode; // No use GroupCodeClicked because it catch only groupcode was clicked
      this.YearClicked = yearClicked;

      //console.log(`Clicked on ${labelClicked} for ${groupChart.assetGroupCode} (${yearClicked}): ${valueClicked} $groubclick: ${this.GroupCodeClicked} `);

      // example datasetIndex
      if (labelClicked === 'Target' || labelClicked === 'Actual') {
        //console.log('User clicked on a Target bar');
        this.isDataReady = false;
        // ทำสิ่งที่คุณต้องการเมื่อคลิก Target
        await Promise.all([
        this.loadTargetGroupDetailList(groupChart.assetGroupCode, yearClicked), // List #2
        this.loadActualPricebyCategoryList(groupChart.assetGroupCode, yearClicked), // List #2
        this.loadActualPricebyTypeList(groupChart.assetGroupCode, yearClicked), // List #3
        this.loadAssetTypeActualMonthlyList(groupChart.assetGroupCode, yearClicked), // Table Actual Asset on Modal
        this.loadActualAssetReportGroupSummaryList(groupChart.assetGroupCode, yearClicked) // Group BarChart of AssetType on Modal
        ]);

        this.isDataReady = true;

        this.generateActualPriceTable();
        this.processChartData(this.ActualAssetReportGroupSummaryList);

        const totalSumAll = this.ActualAssetReportGroupSummaryList.reduce((sum, item) => sum + item.TotalPrice, 0);
        this.TotalPurchasePriceAll = this.formatCurrency(totalSumAll);

      } else if (labelClicked === 'Actual') {
        //console.log('User clicked on an Actual bar!');
      }

    } else {
      //console.log('Clicked outside chart bars or no active element.');
      this.showGroupDetail = false;
    }

    $('#ModalAssetGroupTypeReport').modal('show');
  }

  async loadAssetGroupDetailList(groupCode: string | null = null): Promise<void> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
            })
        };

        var objectjson = {};
        objectjson['AssetGroupCode'] = groupCode;
        let strjson = JSON.stringify(objectjson);

        try {
            const data = await this.httpClient.post<AssetGroupInfo[]>(this.baseurl + "AssetType/GetAssetGroupRelation", strjson, httpOptions).toPromise();
            
            this.AssetGroupDetailList = data;
            //console.log('loadAssetGroupDetailList:', this.AssetGroupDetailList);

        } catch (error) {
            console.error('loadAssetGroupDetailList: Error AssetGroupDetailList:', error);
            this.AssetGroupDetailList = [];
        }
    } else {
        console.error('loadAssetGroupDetailList: Token ไม่พร้อมใช้งาน');
        this.AssetGroupDetailList = [];
    }
}

  async loadTargetGroupDetailList(groupCode: string | null = null, year: string | null = null, teamCode: string | null = null): Promise<void> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
            })
        };

        const yearList = year && year.trim() !== "" ? [year] : [];

        const objectjson: any = {
        SaleTargetYearList: yearList, // string[]
        AssetGroupCode: groupCode,
        SaleTargetEmpCode: this._EmpCode
      };

      if (teamCode !== "") {
        objectjson.SaleTargetTeamCode = teamCode;
      }

        //console.log('loadTargetGroupDetailList: objectjson:', objectjson);

        let strjson = JSON.stringify(objectjson);

        try {
            const data = await this.httpClient.post<ProjectSaleReportInfo[]>(this.baseurl + "ProjectSaleReport/GetAssetCategoryByAssetGroupTargetByReport", strjson, httpOptions).toPromise();
            this.TargetGroupDetailList = data;

            //console.log('load TargetGroupDetailList:', this.TargetGroupDetailList);
        } catch (error) {
            console.error('loadTargetGroupDetailList: Error:', error);
            this.TargetGroupDetailList = []; 
        }
    } else {
        console.error('loadTargetGroupDetailList: Token ไม่พร้อมใช้งาน');
    }
  }

  async loadActualPricebyCategoryList(groupCode: string | null = null, year: string | null = null, teamCode: string | null = null ): Promise<void> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
            })
        };

        const yearList = year && year.trim() !== "" ? [year] : [];

        const objectjson: any = {
        SaleTargetYearList: yearList, // string[]
        AssetGroupCode: groupCode,
        SaleTargetEmpCode: this._EmpCode
      };

      if (teamCode !== "") {
        objectjson.SaleTargetTeamCode = teamCode;
      }

        //console.log('loadTargetGroupDetailList: objectjson:', objectjson);

        let strjson = JSON.stringify(objectjson);

        try {
            const data = await this.httpClient.post<ProjectSaleReportInfo[]>(this.baseurl + "ProjectSaleReport/GetAssetCategoryByAssetGroupActualByReport", strjson, httpOptions).toPromise();
            this.ActualPricebyCategoryList = data;

            //console.log('load ActualPricebyCategoryList:', this.ActualPricebyCategoryList);
        } catch (error) {
            console.error('loadActualPricebyCategoryList: Error:', error);
            this.TargetGroupDetailList = []; 
        }
    } else {
        console.error('loadActualPricebyCategoryList: Token ไม่พร้อมใช้งาน');
    }
  }

  async loadActualPricebyTypeList(groupCode: string | null = null, year: string | null = null, teamCode: string | null = null ): Promise<void> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
            })
        };

        const yearList = year && year.trim() !== "" ? [year] : [];

        const objectjson: any = {
        SaleTargetYearList: yearList, // string[]
        AssetGroupCode: groupCode,
        SaleTargetEmpCode: this._EmpCode
      };

      if (teamCode !== "") {
        objectjson.SaleTargetTeamCode = teamCode;
      }

        //console.log('loadTargetGroupDetailList: objectjson:', objectjson);

        let strjson = JSON.stringify(objectjson);

        try {
            const data = await this.httpClient.post<ProjectSaleReportInfo[]>(this.baseurl + "ProjectSaleReport/GetAssetTypeByAssetGroupActualByReport", strjson, httpOptions).toPromise();
            this.ActualPricebyTypeList = data;

            //console.log('load ActualPricebyTypeList:', this.ActualPricebyTypeList);
        } catch (error) {
            console.error('ActualPricebyTypeList: Error:', error);
            this.ActualPricebyTypeList = []; 
        }
    } else {
        console.error('ActualPricebyTypeList: Token ไม่พร้อมใช้งาน');
    }
  }

  generateActualPriceTable(): any[] {
  const rows: any[] = [];
  const processedKeys = new Set<string>(); // keep key was process
  
  // Step 1: Process Actual Data (have Actual)
  if (this.ActualPricebyCategoryList && this.ActualPricebyCategoryList.length > 0) {
    this.ActualPricebyCategoryList.forEach(cat => {
      const year = cat.ProjectSaleYear;
      const group = cat.AssetGroupCode;
      const category = cat.AssetCategoryCode;
      const key = `${year}-${group}-${category}`;
      
      processedKeys.add(key); // เก็บ key ที่ประมวลผลแล้ว
      
      // Find target at match
      const target = this.TargetGroupDetailList.find(t =>
        t.SaleTargetYear === year &&
        t.AssetGroupCode === group &&
        t.AssetCategoryCode === category
      );
      
      const targetValue = target?.SaleTargetAmount ?? 0;
      
      // Push category row: Target / Actual
      rows.push({
        category: cat.AssetCategoryName,
        type: '',
        price: `${targetValue} / ${cat.TotalActualPrice}`
      });
      
      // Filter type below category
      const typeList = this.ActualPricebyTypeList.filter(t =>
        t.ProjectSaleYear === year &&
        t.AssetGroupCode === group &&
        t.AssetCategoryCode === category
      );
      
      typeList.forEach(type => {
        rows.push({
          category: '',
          type: type.AssetTypeName,
          price: `${type.TotalActualPrice}`
        });
      });
    });
  }
  
  // Step 2: Process Target-Only Data (No Actual)
  if (this.TargetGroupDetailList && this.TargetGroupDetailList.length > 0) {
    // Use data in TargetGroupDetailList (API filter already)
    const targetList = this.TargetGroupDetailList;
    
    targetList.forEach(target => {
      const year = target.SaleTargetYear;
      const group = target.AssetGroupCode;
      const category = target.AssetCategoryCode;
      const key = `${year}-${group}-${category}`;
      
      // Case never process: key (No Actual)
      if (!processedKeys.has(key)) {
        rows.push({
          category: target.AssetCategoryName || 'Unknown Category',
          type: '',
          price: `${target.SaleTargetAmount || 0} / 0`
        });
        
      }
    });
  }
  
  return rows;
}

  formatPrice(value: any): string {
  if (value == null) return '';

  // If string use format "1234 / 5678"
  if (typeof value === 'string' && value.includes('/')) {
    const [target, actual] = value.split('/');
    const formattedTarget = this.formatSingleValue(target);
    const formattedActual = this.formatSingleValue(actual);
    return `${formattedTarget} / ${formattedActual}`;
  }

  // Single number
  return this.formatSingleValue(value);
  }

  getPriceColorClass(priceStr: string): string {
  // If no "/" => AssetType no color
  if (!priceStr.includes('/')) {
    return ''; // return class what to want
  }
  
  const target = this.getTarget(priceStr);
  const actual = this.getActual(priceStr);
  return actual >= target ? 'text-dark-green' : 'text-danger';
 }

  private formatSingleValue(val: any): string {
  const num = Number(val);
  return isNaN(num) ? val : num.toLocaleString(); // format if number
 }

  getTarget(priceStr: string): number {
  const [target] = priceStr.split('/').map(s => s.trim().replace(/,/g, ''));
  return Number(target) || 0;
 }

  getActual(priceStr: string): number {
  const [, actual] = priceStr.split('/').map(s => s.trim().replace(/,/g, ''));
  return Number(actual) || 0;
 }

 async onChartTeamClick(event: any, groupChart: any): Promise<void> {
  if (event.active && event.active.length > 0) {
      const clickedElement = event.active[0];
      const datasetIndex = clickedElement._datasetIndex; // 0 for Target, 1 for Actual
      const elementIndex = clickedElement._index; // Index of dataset (such as 2025)

      const labelClicked = groupChart.datasets[datasetIndex].label;
      const yearClicked = groupChart.labels[elementIndex];
      const valueClicked = groupChart.datasets[datasetIndex].data[elementIndex];

      this.showGroupDetailByTeam = false; // No show table for current
      this.GroupCodeClickedByTeam = groupChart.assetGroupCode; // No use GroupCodeClicked because it catch only groupcode was clicked
      this.YearClickedByTeam = yearClicked;
      //const TeamCodeClicked = this.TeamCodeClick

      //console.log(`Clicked on ${labelClicked} for ${groupChart.assetGroupCode} (${yearClicked}): ${valueClicked} $groubclick: ${this.GroupCodeClicked} `);

      // ตัวอย่างการทำอะไรบางอย่างเพิ่มเติมตาม datasetIndex
      if (labelClicked === 'Target'  || labelClicked === 'Actual') {
        //console.log('User clicked on a Target bar!');
        this.isDataReady = false;
        // ทำสิ่งที่คุณต้องการเมื่อคลิก Target
        await Promise.all([
        this.loadTargetGroupDetailList(groupChart.assetGroupCode, yearClicked, this.TeamCodeClick), // List #2
        this.loadActualPricebyCategoryList(groupChart.assetGroupCode, yearClicked, this.TeamCodeClick), // List #2
        this.loadActualPricebyTypeList(groupChart.assetGroupCode, yearClicked, this.TeamCodeClick), // List #3
        this.loadAssetTypeActualMonthlyList(groupChart.assetGroupCode, yearClicked, this.TeamCodeClick), // List #4 bind groupbarchart modal
        this.loadActualAssetReportGroupTeamSummaryList(groupChart.assetGroupCode, yearClicked, this.TeamCodeClick) // Group BarChart of AssetType on Modal
        ]);

        this.isDataByTeamReady = true;

        this.processChartDataTeam(this.ActualAssetReportGroupTeamSummaryList);
        //this.generateActualPriceTable();

        const totalSumAll = this.ActualAssetReportGroupTeamSummaryList.reduce((sum, item) => sum + item.TotalPrice, 0);
        //console.log('totalSumAll', totalSumAll);
        this.TotalPurchasePriceAllByTeam = this.formatCurrency(totalSumAll);
        //console.log('TotalPurchasePriceAllByTeam', this.TotalPurchasePriceAllByTeam);
      } else if (labelClicked === 'Actual') {
        //console.log('User clicked on an Actual bar!');
      }

    } else {
      //console.log('Clicked outside chart bars or no active element.');
      this.showGroupDetailByTeam = false;
    }

    $('#ModalAssetGroupTypeReportTeam').modal('show');
}

  private clearTableData(): void {
    this.ActualPricebyCategoryList = [];
    this.ActualPricebyTypeList = [];
    this.TargetGroupDetailList = [];
  
    // Clear variable involve table
    this.YearClicked = null;
    this.GroupCodeClicked = null;
  }

  async loadAssetTypeActualMonthlyList(groupCode: string | null = null, year: string | null = null, teamCode: string | null = null) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
            })
        };

        // const startYear = parseInt(this.yearSearch ?? new Date().getFullYear().toString());
        // const yearList = Array.from({ length: this.noYearBack }, (_, i) => (startYear - i).toString());
        const yearList = year && year.trim() !== "" ? [year] : [];

        const objectjson = {
        //AssetGroupCode: groupCode,
        AssetPortfolioCode: groupCode, // เลื่อนระดับจาก AssetGroupCode เป็น AssetPortfolioCode ใน Chart
        SaleTargetYearList: yearList, // string[]
        SaleTargetTeamCode: this.txtSearchSaleTeam, // string | null
        SaleTargetEmpCode: this._EmpCode,
        //AllUnderEmpCode: this._EmpCode
      };

      if (teamCode !== "") {
        objectjson.SaleTargetTeamCode = teamCode;
      }

        //console.log('loadTeamTarget: objectjson ที่จะส่ง:', objectjson);

        let strjson = JSON.stringify(objectjson);

        try {
            // *** แก้ไข 3: ใช้ await ตรงๆ กับ toPromise() ***
            const data = await this.httpClient.post<AssetTypeMonthlySummary[]>(this.baseurl + "ProjectSaleReport/GetAssetTypeMonthlySummary", strjson, httpOptions).toPromise();
            this.AssetTypeActualMonthlyList = data;

            //console.log('AssetTypeActualMonthlyList!!', this.AssetTypeActualMonthlyList);

        } catch (error) {
            console.error('loadTeamActual: Error โหลดยอดรายได้ทีม:', error);
            this.AssetTypeActualMonthlyList = [];
        }
    } else {
        console.error('loadTeamActual: Token ไม่พร้อมใช้งาน');
    }
  }

  async loadActualAssetReportGroupSummaryList(groupCode: string | null = null, year: string | null = null, teamCode: string | null = null) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
            })
        };

        // const startYear = parseInt(this.yearSearch ?? new Date().getFullYear().toString());
        // const yearList = Array.from({ length: this.noYearBack }, (_, i) => (startYear - i).toString());
        const yearList = year && year.trim() !== "" ? [year] : [];

        const objectjson = {
        //AssetGroupCode: groupCode,
        AssetPortfolioCode: groupCode, // เลื่อนระดับจาก AssetGroupCode เป็น AssetPortfolioCode ใน Chart
        SaleTargetYearList: yearList, // string[]
        SaleTargetTeamCode: this.txtSearchSaleTeam, // string | null
        SaleTargetEmpCode: this._EmpCode,
        //AllUnderEmpCode: this._EmpCode
      };

      if (teamCode !== "") {
        objectjson.SaleTargetTeamCode = teamCode;
      }

        //console.log('loadTeamTarget: objectjson ที่จะส่ง:', objectjson);

        let strjson = JSON.stringify(objectjson);

        try {
            // *** แก้ไข 3: ใช้ await ตรงๆ กับ toPromise() ***
            const data = await this.httpClient.post<AssetReportGroupSummary[]>(this.baseurl + "ProjectSaleReport/GetAssetTypebyAssetReportGroupNoChart", strjson, httpOptions).toPromise();
            this.ActualAssetReportGroupSummaryList = data;

            console.log('ActualAssetReportGroupSummaryList!!', this.ActualAssetReportGroupSummaryList);

        } catch (error) {
            console.error('loadTeamActual: Error โหลดยอดรายได้ทีม:', error);
            this.ActualAssetReportGroupSummaryList = [];
        }
    } else {
        console.error('loadTeamActual: Token ไม่พร้อมใช้งาน');
    }
  }

  getTotal(month: string): number {
    //return this.ActualAssetReportGroupSummaryList.reduce((sum, item) => sum + (item[month] || 0), 0);
    return this.AssetTypeActualMonthlyList.reduce((sum, item) => {
    return sum + (item[month] || 0);
  }, 0);
  }

  getTotalByTeam(month: string): number {
    return this.ActualAssetReportGroupTeamSummaryList.reduce((sum, item) => sum + (item[month] || 0), 0);
  }

  private getRandomColor(): string {
    const r = Math.floor(Math.random() * 255);
    const g = Math.floor(Math.random() * 255);
    const b = Math.floor(Math.random() * 255);
    return `rgb(${r}, ${g}, ${b})`;
  }

  // This function processes the API data into a format Chart.js can use.
  public processChartData(dataFromApi: AssetReportGroupSummary[]): void {
    const datasets: any[] = [];
    const monthlyLabels = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    //const colorPalette = [
    //  '#66bb6a', // Green Color "Installment Loan"
    //  '#5e52a9', // Violet "Leasing"
    //  // Add more
    //];

    const groupColorMap: Record<string, { bg: string; hover: string }> = {
      '1': { bg: '#66bb6a', hover: '#81c784' }, // Green for Installment Loan
      '2': { bg: '#5e52a9', hover: '#7969b8' }, // Violet for Leasing
      // Add more AssetReportGroupNo if needed
    };

    const hoverColorPalette = [
      '#81c784', // Light Green "Installment Loan"
      '#7969b8', // Light Violet "Leasing"
      //
    ];

    // Get unique AssetReportGroupNames to use as datasets
    const assetReportGroupNames = [...new Set(dataFromApi.map(item => item.AssetReportGroupName))];

    assetReportGroupNames.forEach((groupName, index) => {
      const dataPoints: number[] = [];
      const monthlyData = dataFromApi.filter(item => item.AssetReportGroupName === groupName);

      monthlyLabels.forEach(month => {
        const sumPrice = monthlyData.reduce((total, current) => {
          return total + (current[month as keyof AssetReportGroupSummary] as number || 0);
        }, 0);
        dataPoints.push(sumPrice);
      });

      const groupNo = monthlyData[0]?.AssetReportGroupNo; // ใช้ AssetReportGroupNo สำหรับ lookup สี
      const colors = groupColorMap[groupNo] || { bg: '#ccc', hover: '#eee' };

      datasets.push({
        label: groupName,
        data: dataPoints,
        backgroundColor: colors.bg,
        borderColor: colors.bg,
        hoverBackgroundColor: hoverColorPalette[index % hoverColorPalette.length],
        borderWidth: 1,
      });
    });

    this.chartLabels = monthlyLabels;
    this.chartDatasets = datasets;
  }

  async loadActualAssetReportGroupTeamSummaryList(groupCode: string | null = null, year: string | null = null, teamCode: string | null = null) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
            })
        };

        // const startYear = parseInt(this.yearSearch ?? new Date().getFullYear().toString());
        // const yearList = Array.from({ length: this.noYearBack }, (_, i) => (startYear - i).toString());
        const yearList = year && year.trim() !== "" ? [year] : [];

        const objectjson = {
        //AssetGroupCode: groupCode,
        AssetPortfolioCode: groupCode, // เลื่อนระดับจาก AssetGroupCode เป็น AssetPortfolioCode ใน Chart
        SaleTargetYearList: yearList, // string[]
        SaleTargetTeamCode: this.txtSearchSaleTeam, // string | null
        SaleTargetEmpCode: this._EmpCode,
        //AllUnderEmpCode: this._EmpCode
      };

      if (teamCode !== "") {
        objectjson.SaleTargetTeamCode = teamCode;
      }

        //console.log('loadTeamTarget: objectjson ที่จะส่ง:', objectjson);

        let strjson = JSON.stringify(objectjson);

        try {
            // *** แก้ไข 3: ใช้ await ตรงๆ กับ toPromise() ***
            const data = await this.httpClient.post<AssetReportGroupSummary[]>(this.baseurl + "ProjectSaleReport/GetAssetTypebyAssetReportGroupNoChart", strjson, httpOptions).toPromise();
            this.ActualAssetReportGroupTeamSummaryList = data;

            console.log('ActualAssetReportGroupTeamSummaryTeamList!!', this.ActualAssetReportGroupTeamSummaryList);

        } catch (error) {
            console.error('loadTeamActual: Error โหลดยอดรายได้ทีม:', error);
            this.ActualAssetReportGroupTeamSummaryList = [];
        }
    } else {
        console.error('loadTeamActual: Token ไม่พร้อมใช้งาน');
    }
  }

  public processChartDataTeam(dataFromApi: AssetReportGroupSummary[]): void {
    const datasets: any[] = [];
    const monthlyLabels = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    // Define color palettes
    const colorPalette = [
      '#66bb6a', // Green Color "Installment Loan"
      '#5e52a9', // Violet "Leasing"
    ];

    const hoverColorPalette = [
      '#81c784', // Light Green "Installment Loan"
      '#7969b8', // Light Violet "Leasing"
    ];

    // Get unique AssetReportGroupNames to use as datasets
    const assetReportGroupNames = [...new Set(dataFromApi.map(item => item.AssetReportGroupName))];

    assetReportGroupNames.forEach((groupName, index) => {
      const dataPoints: number[] = [];
      const monthlyData = dataFromApi.filter(item => item.AssetReportGroupName === groupName);

      monthlyLabels.forEach(month => {
        const sumPrice = monthlyData.reduce((total, current) => {
          return total + (current[month as keyof AssetReportGroupSummary] as number || 0);
        }, 0);
        dataPoints.push(sumPrice);
      });

      datasets.push({
        label: groupName,
        data: dataPoints,
        backgroundColor: colorPalette[index % colorPalette.length],
        borderColor: colorPalette[index % colorPalette.length],
        hoverBackgroundColor: hoverColorPalette[index % hoverColorPalette.length],
        borderWidth: 1,
      });
    });

    this.chartLabelsTeam = monthlyLabels;
    this.chartDatasetsTeam = datasets;
  }

  private formatCurrency(value: number): string {
    if (value >= 1000000000) { // หลักพันล้าน (Billion)
      return `${(value / 1000000000).toFixed(2)}B`;
    }
    if (value >= 1000000) { // หลักล้าน (Million)
      return `${(value / 1000000).toFixed(2)}M`;
    }
    if (value >= 1000) { // หลักพัน (Thousand)
      return `${(value / 1000).toFixed(2)}K`;
    }
      return value.toLocaleString(); // ตัวเลขน้อยกว่าพัน แสดงเป็นตัวเลขปกติ
  }

  async LoadAssetPortfolioMasterList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
            })
        };

        const objectjson = {};
        let strjson = JSON.stringify(objectjson);

        try {
            const data = await this.httpClient.post<AssetPortfolioInfo[]>(this.baseurl + "AssetType/GetAssetPortfolio", strjson, httpOptions).toPromise();
            this.AssetPortfolioMasterList = data;

            //console.log('AssetPortfolioMasterList', this.AssetPortfolioMasterList);
        } catch (error) {
            console.error('AssetPortfolioMasterList:', error);
            this.AssetPortfolioMasterList = []; // ตั้งค่าเป็น array ว่างเปล่าเมื่อเกิดข้อผิดพลาด
        }
    } else {
        console.error('AssetPortfolioMasterList: Token ไม่พร้อมใช้งาน');
    }
  }

}
